/**
 * A grid's tile size, as the Size menu offers it. The grid stays `auto-fill`: a size is the
 * tiles' least width, and the column count still follows the grid's width.
 */
export type TileSize = 'small' | 'medium' | 'large' | 'extraLarge';

export const TILE_SIZES = [
  'small',
  'medium',
  'large',
  'extraLarge'
] as const satisfies ReadonlyArray<TileSize>;

/**
 * At 1200px these give 6, 4, 3 and 2 tiles a row; each size is a different layout on a desktop.
 * Small is the slider's old least width: a resource pane's narrow column still holds two a row.
 */
export const TILE_MIN_WIDTH_PX: Record<TileSize, number> = {
  small: 160,
  medium: 260,
  large: 380,
  extraLarge: 560
};

/** The size closest to a least width the Size slider stored before (160–800px). */
export function tileSizeOfMinWidth(px: number): TileSize {
  return TILE_SIZES.reduce((best, size) =>
    Math.abs(TILE_MIN_WIDTH_PX[size] - px) <
    Math.abs(TILE_MIN_WIDTH_PX[best] - px)
      ? size
      : best
  );
}
